(function($) {
    $(document).ready(function() {
        const subSwiper = new Swiper('.subscriptions .swiper', {
            slidesPerView: 1,
            spaceBetween: 15,
            grabCursor: true,
            breakpoints: {
                767: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                }
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            }
        });

        const productsSwiper = new Swiper('.products-list-swiper .swiper', {
            slidesPerView: 2.1,
            spaceBetween: 10,
            grabCursor: true,
            breakpoints: {
                767: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                }
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            mousewheel: {
                releaseOnEdges: true,
            },
        });

        const brewSwiper = new Swiper('.brew-guide-swiper', {
            slidesPerView: 1,
            grabCursor: true
        });

        brewSwiper.on('slideChange', function () {
            $('.step').removeClass('active');
            $('.step:nth-child(' + (brewSwiper.realIndex + 1) + ')').addClass('active');
        });

        $('.brew-arrow.next-arrow').click(function() {
            brewSwiper.slideNext();
        });

        $('.step-container .step').click(function() {
            var step = $(this).data('step');
            brewSwiper.slideTo(step - 1);
        });

        $('.brew-arrow.prev-arrow').click(function() {
            brewSwiper.slidePrev();
        });
    });
})(jQuery);
